
import { defineComponent, onBeforeMount, ref } from 'vue';

export default defineComponent({
  name: 'Greetings',
  props: {
    proficiency: {
      type: String,
      default: '',
    },
    skill: {
      type: String,
      default: '',
    },
    program: {
      type: String,
      default: '',
    },
  },
  setup() {
    const username = ref('');
    onBeforeMount(async () => {
      const item = localStorage.getItem('userName') || 'Learner';
      username.value = item.split(',').reverse().join(' ');
    });
    return { username };
  },
});
